import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=cc59abe6&"
import script from "./InputArea.vue?vue&type=script&lang=js&"
export * from "./InputArea.vue?vue&type=script&lang=js&"
import style0 from "./InputArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports